module.exports = __webpack_public_path__ + "img/tuto_internet_way_02_04.ce737972.png";